var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChest2Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 100,
    viewBox: "0 0 55 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96577 88.4384C8.96577 88.4384 10.1523 89.5864 12.5906 90.3131C12.5906 90.3131 16.2807 92.0662 19.511 91.9802L23.9338 91.4166C25.1945 91.2386 26.5145 90.4555 26.8141 89.2185L27.3361 84.6148L28.8697 84.5941L28.9706 89.7198C29.2553 89.5092 30.1245 89.2215 30.6673 88.9278C32.8653 87.7472 35.3274 87.6761 38.1661 87.6108C41.2867 87.5366 42.6364 87.943 43.0427 88.0735C43.2652 88.1447 44.3657 88.3672 44.5645 88.4443C45.2615 87.949 44.1432 87.6464 44.8374 87.151C45.1192 81.2362 45.2823 75.4786 44.0009 68.3654C43.5322 66.4789 43.4521 65.0936 41.4261 61.4272C41.2659 61.534 40.1239 61.8455 39.8124 62.0383C32.9425 66.2178 25.3576 64.9038 24.4529 64.8059C21.8129 64.5211 20.564 63.9249 16.2125 63.6193C14.9192 63.5274 13.8572 63.7944 13.1809 63.7855L10.4934 72.3106L8.95984 88.4443L8.96577 88.4384Z",
    fill: "#909091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6514 3.62915C32.7794 6.74673 33.3192 8.87061 33.6514 9.82576C33.8027 10.2588 33.9362 10.6356 34.2447 11.0775C35.1999 12.445 36.6 13.4209 39.0561 14.3227C39.9074 14.6371 42.1974 15.2541 43.6716 15.966",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4113 16.0222C42.4228 15.8828 45.3713 16.043 45.2497 16.0222C45.5819 16.0786 46.8841 16.3426 48.2812 18.0007C50.7077 20.8751 51.3721 25.5055 51.117 28.2167C51.0785 28.6112 50.9568 29.6553 51.117 31.0525L50.9183 42.1257C50.3754 46.2577 50.9331 45.8751 50.3903 47.8595C49.7407 50.2326 48.6698 51.781 46.8307 54.3854C45.6412 56.0703 43.897 58.9179 41.4913 61.374",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5259 27.2766C44.52 28.9852 44.7751 30.5425 44.5763 31.5778C44.5763 31.5778 44.3539 34.6953 43.6034 36.1933C43.3809 36.6412 43.105 37.0091 43.105 37.0091C43.105 37.0091 42.1351 38.5011 41.874 38.7621",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7369 99.5417C44.0988 96.7653 44.5348 92.823 44.7929 88.071C45.1667 81.1714 45.4158 76.5469 44.4636 70.8012C43.9297 67.5857 43.8407 66.7374 41.4321 61.4247C41.3045 61.6235 43.553 59.6657 42.6038 55.2785C41.8829 51.9474 41.3816 47.9844 41.8266 46.608C42.6067 44.1875 43.3958 41.767 43.286 36.748",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5616 27.6086C10.8938 28.1396 11.1371 29.3677 11.2706 30.3614C11.3655 31.0703 11.2943 32.951 11.2706 33.1467C10.8879 36.2732 11.2053 41.0816 11.2706 41.9151C11.5761 45.8395 11.9054 45.1543 12.4897 49.4288C12.7745 51.4992 11.6473 53.6943 11.6503 59.4638C11.6503 62.3411 12.9851 63.6996 12.9851 63.6996C12.7864 65.4379 11.2735 68.4339 11.057 70.6705C10.9324 71.9549 10.6981 73.0079 10.6447 73.702C9.83784 77.4366 10.1345 81.4174 9.50858 85.6325C8.7937 90.4379 8.45554 95.0001 8.14111 99.2775",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4707 99.2775C25.1767 96.0412 25.9242 92.7664 26.7132 89.456C27.1167 87.7682 27.0425 86.2376 27.4548 84.5794C28.0036 84.6239 28.5523 84.6684 29.1041 84.71C29.3533 84.707 29.6173 84.6922 29.8902 84.6655C30.7949 84.5735 31.572 84.357 32.2009 84.1167",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7122 99.2776C29.4927 96.51 29.2732 93.7395 29.0536 90.9719C28.8104 88.8747 29.0121 86.7805 28.7719 84.6833",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.801 4.71777C21.8396 5.10933 21.807 8.78161 21.4391 9.97999C21.3531 10.2588 21.0743 11.392 20.4662 12.1662C19.3093 13.6345 18.7428 13.9548 17.1528 14.5392C16.0701 14.9367 14.581 15.438 10.9147 17.2682L8.86495 17.7369C8.43483 17.8852 7.27797 18.2797 6.29316 19.0539C4.96722 20.0981 4.55193 20.3769 3.44253 28.9258C3.01538 32.2213 2.79884 33.7223 2.78401 34.9741C2.73952 38.3764 3.39804 39.29 3.59085 44.401C3.71543 47.6728 3.51966 47.6995 3.78959 48.9483C4.17818 50.7637 4.35022 53.8308 6.82116 57.2213C8.23312 59.1554 10.2028 61.6797 12.7805 64.4977",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.321 32.4202C11.321 32.4202 11.1668 37.9286 12.7686 38.7651L11.321 32.4202Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.321 32.4202C11.321 32.4202 11.1668 37.9286 12.7686 38.7651",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.274 -0.0519539C35.3393 0.971421 34.0222 1.60028 34.0222 1.60028L34.0163 1.53205C34.0163 2.43381 33.8947 4.11867 32.981 5.95481C32.4441 7.03158 31.3436 8.12021 30.4508 8.755C29.6736 9.3097 28.757 9.62413 27.8019 9.65676C26.82 9.69235 25.85 9.42835 25.0195 8.90035C24.1889 8.37234 23.3198 7.49135 22.4833 6.23661C21.0446 4.07714 20.8429 2.28253 20.742 1.26212H20.7806C20.7806 1.26212 19.6593 0.591734 19.5822 -0.431641",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.274 -0.0519539C35.3393 0.971421 34.0222 1.60028 34.0222 1.60028L34.0163 1.53205C34.0163 2.43381 33.8947 4.11867 32.981 5.95481C32.4441 7.03158 31.3436 8.12021 30.4508 8.755C29.6736 9.3097 28.757 9.62413 27.8019 9.65676C26.82 9.69235 25.85 9.42835 25.0195 8.90035C24.1889 8.37235 23.3198 7.49135 22.4833 6.23661C21.0446 4.07714 20.8429 2.28253 20.742 1.26212H20.7806C20.7806 1.26212 19.6593 0.591734 19.5822 -0.431641",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 9.25562C17.2832 9.25562 13.3795 10.6082 9.99793 12.3228C6.93373 13.8771 5.45948 14.3814 0.505737 16.5587",
    stroke: "black",
    strokeWidth: 0.889892,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.14 7.35425C36.14 7.35425 39.9043 9.16666 43.4253 10.5697C50.8766 13.539 50.1618 12.922 54.015 15.2505",
    stroke: "black",
    strokeWidth: 0.889892,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3836 53.6915C27.3836 53.0567 27.7307 52.5405 28.1548 52.5405C28.579 52.5405 28.9261 53.0567 28.9261 53.6915",
    stroke: "black",
    strokeWidth: 0.296631,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChest2Male);
export default __webpack_public_path__ + "static/media/chest-2-male.bd5fa8f32db3079158f324ee0c0d3440.svg";
export { ForwardRef as ReactComponent };